var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExamPhases(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.136,
    height: 93.877,
    viewBox: "0 0 84.136 93.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5f45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff357d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 84.136,
    height: 93.877
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.325,46.782a3.046,3.046,0,0,1-3.263,1.8c-1.913-.085-3.833-.042-5.75-.008-.616.01-.909-.023-.753-.8a9.766,9.766,0,0,0-.037-3.625c-.067-.381.035-.464.385-.462,2.375.01,4.752-.017,7.127.019a2.659,2.659,0,0,1,2.29,1.768Z",
    transform: "translate(35.666 40.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.676,45.6A12.54,12.54,0,0,0,10.4,43.345a.622.622,0,0,1,.74-.019,10.08,10.08,0,0,0,4.257.828c9.593-.012,19.188,0,28.781-.021.692,0,.838.121.713.834a9.592,9.592,0,0,0,.035,3.469c.1.507-.048.634-.5.58a2.041,2.041,0,0,0-.243,0H15.071a14.356,14.356,0,0,1-8.431-2.668c-.285-.2-.551-.426-.963-.745",
    transform: "translate(5.258 40.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.9,20.782a10.949,10.949,0,0,0-3.808,1.429,2.379,2.379,0,0,1-2.83.212,7.582,7.582,0,0,0-3.554-.636c-6.157.008-12.313-.008-18.469.019-.668,0-.9-.112-.749-.821a9.484,9.484,0,0,0-.013-3.465c-.069-.435-.025-.609.485-.607,6.563.019,13.124-.04,19.685.046a13.571,13.571,0,0,1,8.589,3.34c.164.137.345.252.665.482",
    transform: "translate(21.721 15.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.727,33.83c.013-.281.212-.354.354-.464a13.631,13.631,0,0,1,8.306-3.024c5.243-.071,10.489-.025,15.732-.023a5,5,0,0,1,.5.05,12.8,12.8,0,0,0-.025,4.377c.133.713-.41.422-.657.424-4.513.017-9.029.031-13.544,0a11.9,11.9,0,0,0-5.461.894.5.5,0,0,1-.6-.029,12.6,12.6,0,0,0-4.61-2.208",
    transform: "translate(5.305 28.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44.661,32.488A14.149,14.149,0,0,1,36.5,35.453c-1.618.065-3.242,0-4.864.031-.528.01-.618-.127-.526-.643a10.177,10.177,0,0,0,.01-3.631c-.1-.58.1-.6.559-.611A45.221,45.221,0,0,0,37.5,30.46a2.159,2.159,0,0,0,.63-.137,2.454,2.454,0,0,1,3.088.5,6.086,6.086,0,0,0,1.607.923c.559.266,1.148.468,1.836.742",
    transform: "translate(28.786 27.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.866,21.79c-1.564,0-3.13-.019-4.694.012-.491.01-.655-.119-.638-.628.037-1.214.025-2.429,0-3.643-.008-.426.071-.62.562-.616q4.736.032,9.47,0c.433,0,.562.114.484.555a10.569,10.569,0,0,0,0,3.781c.085.458-.079.549-.5.545-1.564-.019-3.13-.008-4.694-.008",
    transform: "translate(5.125 15.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.973.887h0A1.488,1.488,0,0,0,.486,2.374V35.16a1.487,1.487,0,1,0,2.974,0V2.374A1.488,1.488,0,0,0,1.973.887",
    transform: "translate(0.45 0.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.874,10.32q-8.281,3.386-16.566,6.771c-1.106.451-1.67.079-1.678-1.111-.013-2.009,0-4.018,0-6.029s-.006-4.02,0-6.029c0-1.329.484-1.684,1.716-1.268q8.244,2.791,16.485,5.588c.491.166.915.391.95.973.039.634-.4.9-.905,1.106",
    transform: "translate(2.429 2.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.961,14.394a7.3,7.3,0,1,0,7.291,7.27,7.292,7.292,0,0,0-7.291-7.27m0,11.19a3.893,3.893,0,1,1,3.893-3.893,3.893,3.893,0,0,1-3.893,3.893",
    transform: "translate(12.657 13.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.4,21.381a7.3,7.3,0,1,0,7.291,7.27,7.292,7.292,0,0,0-7.291-7.27m0,11.19a3.893,3.893,0,1,1,3.893-3.893A3.893,3.893,0,0,1,43.4,32.571",
    transform: "translate(33.443 19.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.355,27.765a7.3,7.3,0,1,0,7.291,7.27,7.291,7.291,0,0,0-7.291-7.27m0,11.19a3.893,3.893,0,1,1,3.893-3.893,3.893,3.893,0,0,1-3.893,3.893",
    transform: "translate(19.506 25.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.784,34.5a7.3,7.3,0,1,0,7.291,7.27A7.292,7.292,0,0,0,7.784,34.5m0,11.19A3.893,3.893,0,1,1,11.675,41.8a3.893,3.893,0,0,1-3.893,3.893",
    transform: "translate(0.451 31.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.766,41.158a7.3,7.3,0,1,0,7.291,7.27,7.292,7.292,0,0,0-7.291-7.27m0,11.19a3.893,3.893,0,1,1,3.893-3.893,3.893,3.893,0,0,1-3.893,3.893",
    transform: "translate(26.371 38.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.793,2.4A2.4,2.4,0,1,1,2.4,0a2.4,2.4,0,0,1,2.4,2.4",
    transform: "translate(0 -0.001)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExamPhases);
export default __webpack_public_path__ + "static/media/icon-exam-phases.2ea5c6ab358bcec9870bb7a609a841f1.svg";
export { ForwardRef as ReactComponent };